// extracted by mini-css-extract-plugin
export default {"header":"styles_header__TII-M","infoContainer":"styles_infoContainer__Y-Yul","loginBtns":"styles_loginBtns__LXAEv","loginedWrapper":"styles_loginedWrapper__UtkP2"};